// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".uPPMZBU\\+17VcVh {\n  display: block;\n  height: auto;\n  max-height: 100%;\n  max-width: 100%;\n  width: auto;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": "uPPMZBU+17VcVh"
};
export default ___CSS_LOADER_EXPORT___;
